var React = require('react');

function SymbolTrustedInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M37.5007 0H52.5007V90H37.5007V0Z","fill":"#FF5AA9","key":0}),React.createElement("path",{"d":"M7.87615 18.4837L18.4828 7.87708L82.1224 71.5167L71.5158 82.1233L7.87615 18.4837Z","fill":"#FF5AA9","key":1}),React.createElement("path",{"d":"M82.1241 18.4837L71.5175 7.87708L7.87789 71.5167L18.4845 82.1233L82.1241 18.4837Z","fill":"#FF5AA9","key":2}),React.createElement("path",{"d":"M0 52.4998V37.4998H90V52.4998H0Z","fill":"#FF5AA9","key":3})]);
}

SymbolTrustedInline.defaultProps = {"width":"199","height":"199","viewBox":"-54.5 -54.5 199 199","fill":"none"};

module.exports = SymbolTrustedInline;

SymbolTrustedInline.default = SymbolTrustedInline;
